module.exports = __webpack_public_path__ + "img/lazer.34cb2e36.svg";